module.exports = __webpack_public_path__ + "static/img/BS.b5dc7a65.svg";